"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "StyledButton", {
  enumerable: true,
  get: function get() {
    return _button.StyledButton;
  }
});
exports.RadiosNavigation = exports.Checkmark = exports.Button = exports.Box = exports.StyledRadioButton = exports.RadioLabel = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _button = require("../button");

var _fontIcon = require("../font-icon");

var _label = require("../label");

var _tokens = require("../../../tokens");

var _utilities = require("../../_utils/utilities");

var _versions = require("../../_utils/versions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          ", ":last-child {\n            margin-right: 0;\n          }\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n          flex-direction: column;\n          ", ":last-child {\n            margin-bottom: 0;\n          }\n        "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: ", ";\n  ", ";\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: ", ";\n  padding-left: ", ";\n  cursor: ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  opacity: 0;\n  position: absolute;\n  user-select: none;\n  cursor: ", ";\n\n  &:checked + ", " {\n    background-color: ", ";\n    border-color: ", ";\n    &:after {\n      display: block;\n    }\n\n    &:hover {\n      &:after {\n        background-color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    border-radius: 0;\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background: ", ";\n      border-color: ", ";\n\n      &:hover {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n      }\n      &:active {\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        z-index: 1;\n        color: ", ";\n        background: ", ";\n        border-color: ", ";\n\n        &:hover {\n          background: ", ";\n          border-color: ", ";\n        }\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      height: ", ";\n      line-height: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  ", ";\n  vertical-align: middle;\n  min-width: 32px;\n  text-align: center;\n\n  ", " {\n    vertical-align: text-top;\n    margin-right: ", ";\n  }\n  ", "\n\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 50%;\n  outline: none;\n  cursor: ", ";\n\n  &:hover, &:focus {\n    outline: none;\n    box-shadow: ", ";\n    border-color: ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    background-color: ", ";\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    margin: auto;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        &:first-child span{\n          border-top-left-radius: ", ";\n          border-bottom-left-radius: ", ";\n        }\n        &:last-child span{\n          border-top-right-radius: ", ";\n          border-bottom-right-radius: ", ";\n        }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          margin-right: ", ";\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          margin-bottom: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  height: ", ";\n  position: relative;\n  cursor: pointer;\n\n  > ", " {\n    padding-left: ", ";\n    vertical-align: 3px;\n  }\n\n  ", ";\n\n  ", "\n\n  z-index: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var width = '18px';
var height = '18px';

var getStyles = function getStyles(props) {
  var radioColors = (0, _versions.getColor)(props, 'radio');
  var buttonColors = (0, _versions.getColor)(props, 'button');
  return {
    border: radioColors.border,
    off: radioColors.offBackground,
    on: radioColors.onBackground,
    text: radioColors.text,
    backFill: radioColors.backFill,
    borderHover: radioColors.borderHover,
    checkedHover: radioColors.checkedHover,
    buttonColors: buttonColors
  };
};

var StyledRadioButton = _styledComponents["default"].span(_templateObject(), function (props) {
  return props.type !== 'button' && height;
}, _fontIcon.StyledIcon, _tokens.spacing.xsmall, function (props) {
  return props.layout === 'vertical' ? (0, _styledComponents.css)(_templateObject2(), _tokens.spacing.medium) : (0, _styledComponents.css)(_templateObject3(), function (props) {
    if (props.noSpace) {
      return '-1px';
    }

    if ((0, _utilities.validCssUnit)(props.spaceBetween)) {
      return props.spaceBetween;
    }

    return _tokens.spacing.medium;
  });
}, function (props) {
  var _getProperties = (0, _versions.getProperties)(props, 'button'),
      radius = _getProperties.radius;

  if (props.noSpace) {
    return (0, _styledComponents.css)(_templateObject4(), radius, radius, radius, radius);
  }
}, function (props) {
  return props.checked && 1;
});

exports.StyledRadioButton = StyledRadioButton;

var Checkmark = _styledComponents["default"].span(_templateObject5(), height, width, function (props) {
  return getStyles(props).off;
}, function (props) {
  return getStyles(props).border;
}, function (props) {
  return props.checked ? 'auto' : 'pointer';
}, function (props) {
  return props.shadowOnHover && "0 0 0 1px rgba(0, 0, 0, 0.3)";
}, function (props) {
  return getStyles(props).borderHover;
}, function (props) {
  return getStyles(props).on;
});

exports.Checkmark = Checkmark;

var Button = _button.StyledButton.withComponent('span').extend(_templateObject6(), function (props) {
  var _getProperties2 = (0, _versions.getProperties)(props, 'button'),
      height = _getProperties2.height;

  return (0, _styledComponents.css)(_templateObject7(), height, height);
}, _fontIcon.StyledIcon, function (props) {
  return props.text && '12px';
}, function (props) {
  if (props.checked) {
    return (0, _styledComponents.css)(_templateObject8(), function (props) {
      return getStyles(props).buttonColors["default"].text;
    }, function (props) {
      return props.activeColor || getStyles(props).buttonColors["default"].background;
    }, function (props) {
      return props.activeBorderColor || getStyles(props).buttonColors["default"].border;
    }, function (props) {
      return props.activeColor || getStyles(props).buttonColors["default"].backgroundHover;
    }, function (props) {
      return props.activeBorderColor || getStyles(props).buttonColors["default"].borderHover;
    });
  }

  return (0, _styledComponents.css)(_templateObject9(), function (props) {
    return getStyles(props).buttonColors.secondary.text;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.background;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.border;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.borderHover;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.backgroundHover;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.borderHover;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.borderHover;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.backgroundActive;
  }, function (props) {
    return getStyles(props).buttonColors.secondary.borderActive;
  });
}, function (props) {
  return props.noSpace && (0, _styledComponents.css)(_templateObject10());
});

exports.Button = Button;

var Box = _styledComponents["default"].input(_templateObject11(), function (props) {
  return props.checked ? 'auto' : 'pointer';
}, Checkmark, function (props) {
  return getStyles(props).backFill;
}, function (props) {
  return getStyles(props).borderHover;
}, function (props) {
  return getStyles(props).checkedHover;
});

exports.Box = Box;

var RadioLabel = _label.StyledLabelText['label1'].extend(_templateObject12(), function (props) {
  return props.type !== 'button' && 'super';
}, _tokens.spacing.xsmall, function (props) {
  return props.checked ? 'auto' : 'pointer';
});

exports.RadioLabel = RadioLabel;

var RadiosNavigation = _styledComponents["default"].div(_templateObject13(), function (props) {
  return !props["native"] && _tokens.spacing.small;
}, function (props) {
  return props.layout === 'vertical' ? (0, _styledComponents.css)(_templateObject14(), StyledRadioButton) : (0, _styledComponents.css)(_templateObject15(), StyledRadioButton);
});

exports.RadiosNavigation = RadiosNavigation;